import React from "react";
import { Link } from "react-router-dom";

const TermsOfService: React.FC = () => {
  return (
    <div className="min-h-screen bg-white transition-colors duration-200">
      <div className="container mx-auto px-6 py-12 max-w-4xl">
        <div className="mb-8 flex items-center justify-between">
          <Link
            to="/"
            className="flex items-center hover:opacity-90 transition-opacity"
          >
            <img
              src="/a.png"
              alt="Einstein AI"
              className="w-12 h-12 object-contain mr-3"
            />
            <span className="text-xl font-semibold text-gray-900">
              Einstein AI
            </span>
          </Link>
        </div>

        <div className="bg-white shadow-sm border border-gray-100 rounded-lg p-8">
          <h1 className="text-3xl font-bold mb-6 text-gray-900 text-center">
            Terms of Service
          </h1>
          <p className="text-gray-600 mb-8 text-center italic">
            Effective Date: March 23, 2025
          </p>

          <div className="prose prose-lg max-w-none text-gray-700">
            <p>
              Welcome to Einstein AI ("the Service"), available at
              einsteinstudy.com ("the Website"). By accessing or using our
              Service, you agree to be bound by these Terms of Service
              ("Terms"). If you do not agree, please do not use the Service.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-3 text-gray-900 dark:text-white">
              1. Overview
            </h2>
            <p>
              Einstein AI is an AI-powered study platform that provides learning
              assistance on various topics through a subscription-based model.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-3 text-gray-900 dark:text-white">
              2. Account Registration
            </h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>You must sign in using a Google account.</li>
              <li>
                You are responsible for maintaining the security of your account
                and password.
              </li>
              <li>
                Any unauthorized use of your account must be reported
                immediately.
              </li>
            </ul>

            <h2 className="text-xl font-semibold mt-6 mb-3 text-gray-900 dark:text-white">
              3. Subscription & Payments
            </h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Einstein AI operates on a subscription basis.</li>
              <li>
                Subscription fees, billing cycles, and payment details will be
                outlined during sign-up.
              </li>
              <li>
                We reserve the right to change pricing, and any changes will be
                communicated in advance.
              </li>
              <li>
                Subscriptions renew automatically unless canceled before the
                renewal date.
              </li>
            </ul>

            <h2 className="text-xl font-semibold mt-6 mb-3 text-gray-900 dark:text-white">
              4. Cancellations & Refunds
            </h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>
                You can cancel your subscription at any time through your
                account settings.
              </li>
              <li>Refunds are not provided except as required by law.</li>
            </ul>

            <h2 className="text-xl font-semibold mt-6 mb-3 text-gray-900 dark:text-white">
              5. Acceptable Use
            </h2>
            <p>You agree not to:</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Use the Service for unlawful or fraudulent activities.</li>
              <li>
                Attempt to interfere with the security or functionality of the
                Website.
              </li>
              <li>
                Copy, modify, or distribute any content without permission.
              </li>
            </ul>

            <h2 className="text-xl font-semibold mt-6 mb-3 text-gray-900 dark:text-white">
              6. Intellectual Property
            </h2>
            <p>
              All content, trademarks, and intellectual property related to
              Einstein AI are owned by or licensed to us. Unauthorized use is
              prohibited.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-3 text-gray-900 dark:text-white">
              7. Limitation of Liability
            </h2>
            <p>
              We provide the Service "as is" without warranties of any kind. We
              are not liable for any indirect, incidental, or consequential
              damages arising from your use of the Service.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-3 text-gray-900 dark:text-white">
              8. Modifications to the Terms
            </h2>
            <p>
              We may update these Terms from time to time. Continued use of the
              Service after changes means you accept the revised Terms.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-3 text-gray-900 dark:text-white">
              9. Contact Information
            </h2>
            <p>
              If you have questions regarding these Terms, contact us at{" "}
              <a
                href="mailto:catyardapp@gmail.com"
                className="text-blue-600 hover:underline dark:text-blue-400"
              >
                catyardapp@gmail.com
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
